export default "__VITE_ASSET__sLd1VNaf__";